export enum SearchMatchType {
  CloseVariant = 1,
  ExactMatch = 2,
  PartialMatch = 3,
}
